import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContextProvider.jsx";
import { showErrorToast } from "../services/toastService.js";
import NotAuthorizedPage from "../pages/errors/NotAuthorizedPage.jsx";

export default function ProtectedRoute({ children, requiredLevel }) {
	const { user, loading } = useAuth();

	if (loading) {
		return (
			<div className="flex items-center justify-center h-screen">
				<p className="text-lg font-bold text-gray-700">Caricamento in corso...</p>
			</div>
		);
	}

	if (!user) {
		showErrorToast("Devi effettuare l'accesso per visualizzare questa pagina.");
		return <Navigate to="/" replace />;
	}

	if (user.level > requiredLevel) {
		return <NotAuthorizedPage />;
	}

	return children;
}
